import { render, staticRenderFns } from "./Page-4.vue?vue&type=template&id=1e3b6c74&scoped=true&"
var script = {}
import style0 from "./Page-4.vue?vue&type=style&index=0&id=1e3b6c74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b6c74",
  null
  
)

export default component.exports